import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://mylaw.it.kr";
const SITE_NAME = "마이로잇";
const DEFAULT_IMAGE = `${SITE_URL}/og-card.svg`;

export default function SEOHead({
  title,
  description,
  keywords,
  path = "",
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : "마이로잇 | AI 법률·세무 정보 검색 - 파산, 이혼, 임금체불, 세무 정보";
  const fullUrl = `${SITE_URL}${path}`;
  const metaDescription =
    description ||
    "마이로잇은 AI 기반 법률·세무 정보 안내 서비스입니다. 개인파산, 임금체불, 부당해고, 전세사기, 이혼, 상속, 교통사고, 손해배상 등 법률 정보와 종합소득세, 부가가치세 등 세무 정보를 쉽게 검색하세요. (본 서비스는 법률자문이 아닙니다)";
  const metaKeywords =
    keywords ||
    "법률정보,법률정보검색,법률AI,파산,개인파산,임금체불,부당해고,전세사기,이혼정보,상속,교통사고,손해배상,세무정보,종합소득세,마이로잇";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="마이로잇 - AI 법률·세무 정보 안내" />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
}
